export interface formParams {
  userId?: string; // 用户ID
  deptId?: string; // 部门ID
  deptName?: string; // 部门名称
  userName?: string; // 用户账号
  nickName?: string; // 用户昵称
  email?: string; // 用户邮箱
  phonenumber?: string; // 手机号码
  sex?: string; // 用户性别
  avatar?: string; // 用户头像
  password?: string; // 密码
  salt?: string; // 盐加密
  status?: string; // 帐号状态（0正常 1停用）
  delFlag?: string; // 删除标志（0代表存在 2代表删除）
  loginIp?: string; // 最后登录IP
  loginDate?: string; // 最后登录时间
  remark?: string; // 备注
  kingdeeCode?: string; // 金蝶编码
}

// 上级组织
export function getTreeSelect() {
  return request({
    url: '/system/dept/treeselect',
    method: 'get',
  });
}
// 用户列表
export function getUserList(query: any) {
  return request({
    url: '/system/user/list',
    method: 'get',
    params: query,
  });
}

// 用户列表-不分页
export function getAllUserList(query: any) {
  return request({
    url: '/system/user/listAll',
    method: 'get',
    params: query,
  });
}

// 新增用户
export function addUser(data: any) {
  return request({
    url: '/system/user',
    method: 'post',
    data,
  });
}

// 查询用户信息
export function getUserInfo(id: any) {
  return request({
    url: `/system/user/${id}`,
    method: 'get',
  });
}

// 根据用户编号获取授权角色
export function getUserAuthRole(id: any) {
  return request({
    url: `/system/user/authRole/${id}`,
    method: 'get',
  });
}

// 根据楼宇产权人获取用户
export function getUserPropertyInfo(userId: any) {
  return request({
    url: `/system/user/property/${userId}`,
    method: 'get',
  });
}

// 修改用户
export function updateUser(data: any) {
  return request({
    url: '/system/user',
    method: 'put',
    data,
  });
}

// 修改用户密码
export function updateUserResetPwd(data: any) {
  return request({
    url: '/system/user/resetPwd',
    method: 'put',
    data,
  });
}
// 修改用户密码-传入旧密码
export function updateUserPasswd(data: any) {
  return request({
    url: '/system/user/updatePwd',
    method: 'put',
    data,
  });
}

// 用户授权角色
export function updateUserRole(data?: any) {
  return request({
    url: '/system/user/authRole',
    method: 'put',
    data,
  });
}

// 修改用户
export function editUser(data: any) {
  return request({
    url: '/system/user/editUser',
    method: 'post',
    data,
  });
}

// 关联签章使用权限
export function associateAuth(data = {}) {
  return request({
    url: '/zcSignUser/addUserLink',
    method: 'post',
    data,
  });
}

// 新增绑定关联账号
export function saveSysUserBind(data: {userId: string, bindUserId: string}) {
  return request({
    url: '/sysUserBind/saveSysUserBind',
    method: 'post',
    data,
  });
}

// 解绑关联账号
export function unbindSysUserBind(data: { id: string }) {
  return request({
    url: '/sysUserBind/unbindSysUserBind',
    method: 'put',
    data,
  });
}

// 获取已绑定用户
export function getFixedAssetArchiveById(userId: string) {
  return request({
    url: '/sysUserBind/getFixedAssetArchiveById',
    method: 'get',
    params: { userId },
  });
}

